import { render, staticRenderFns } from "./TerpeneStackedBar.vue?vue&type=template&id=2c7f032d"
import script from "./TerpeneStackedBar.vue?vue&type=script&lang=js"
export * from "./TerpeneStackedBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports